import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

interface ContainerProps {
  readonly $isVisible: boolean;
  readonly role?: string;
  readonly 'aria-live'?: 'polite' | 'assertive' | 'off';
  readonly 'aria-busy'?: boolean;
}

export const Container = styled.div<ContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${(props) => (props.$isVisible ? 'none' : fadeOut)} 800ms ease-out forwards;
`;

export const SpinningImage = styled.img`
  width: 300px;
  height: 300px;
  animation: ${spin} 3.5s linear infinite;

  @media (max-width: 1024px) {
    width: 250px;
    height: 250px;
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 200px;
  }
`;

export const LoadingText = styled.div`
  font-family: 'SyneMono', Arial, sans-serif;
  font-size: clamp(20px, 4vw, 32px);
  color: #ffffff;
  letter-spacing: 3px;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  margin-top: 2rem;
  text-align: center;
`;
